import { createSelector } from 'reselect';

import { TaskStatus } from 'constants/tasks';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyTasks = createSelector(
  selectSubCompany,
  subCompany => subCompany?.tasks || [],
);

// DEV-4923 SubCompany header "Open Review Tasks" field — count of open (New/Submitted)
// sub-company-targeted tasks, derived from the same tasks list the Tasks tab reads.
const OPEN_REVIEW_TASK_STATUSES = [TaskStatus.NEW, TaskStatus.SUBMITTED];

const selectSubCompanyOpenReviewTasksList = createSelector(selectSubCompanyTasks, tasks =>
  tasks.filter(task => OPEN_REVIEW_TASK_STATUSES.includes(task?.status)),
);

export const selectSubCompanyOpenReviewTasksCount = createSelector(
  selectSubCompanyOpenReviewTasksList,
  tasks => tasks.length,
);

// DEV-5115 cert-review "Review Findings" — the open (New/Submitted) sub-company-targeted
// tasks (the AI-decisioning findings) surfaced inline on the certification review surface.
export const selectSubCompanyOpenReviewTasks = selectSubCompanyOpenReviewTasksList;

export const selectSubCompanyTasksLoading = createSelector(
  selectSubCompany,
  subCompany => subCompany?.tasksStatus?.loading ?? false,
);

export const selectSubCompanyTasksError = createSelector(
  selectSubCompany,
  subCompany => subCompany?.tasksStatus?.error ?? null,
);

export const selectSubCompanyTaskUsers = createSelector(
  selectSubCompany,
  subCompany => subCompany?.taskUsers || [],
);

export const selectSubCompanyTaskUserOptions = createSelector(selectSubCompanyTaskUsers, users =>
  users
    .filter(({ isEnabled }) => isEnabled)
    .map(({ id, displayName, email }) => ({ value: id, name: displayName || email })),
);
